import React, { createElement } from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initFbPixel } from './lib/fbpixel';
// Facebook domain verification meta tag (injected into <head>)
if (typeof document !== 'undefined' && !document.querySelector('meta[name="facebook-domain-verification"]')) {
  const meta = document.createElement('meta');
  meta.name = 'facebook-domain-verification';
  meta.content = 'j0j6qt7ow47h1hasglvxa6ob8ltlbo';
  document.head.appendChild(meta);
}
// Initialize Meta Pixel (fires PageView)
initFbPixel();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-193" />);
}